import React, { useState, useEffect } from 'react';
import './SocialNav.css';

const SocialNav = () => {
  const [isFooterOverlap, setIsFooterOverlap] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.footer');
      const socialNav = document.querySelector('.social-nav');
      
      if (footer && socialNav) {
        const footerRect = footer.getBoundingClientRect();
        const socialNavRect = socialNav.getBoundingClientRect();
        
        // Check if social nav is overlapping with footer
        const isOverlapping = socialNavRect.bottom > footerRect.top;
        setIsFooterOverlap(isOverlapping);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const socialLinks = [
    {
      name: 'LinkedIn',
      url: 'https://linkedin.com/in/caleydames',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    {
      name: 'Behance',
      url: 'https://behance.net/caleydames1',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M22 7h-7V5h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.561-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426H24c-.468-4.012-3.248-7.024-7.608-7.024-4.695 0-8.301 3.298-8.301 8.883 0 5.576 3.606 8.883 8.301 8.883 4.358 0 7.139-3.012 7.608-7.024h-2.284zM13.25 13.25c0 2.268 1.453 3.611 3.269 3.611s3.269-1.343 3.269-3.611c0-2.267-1.453-3.611-3.269-3.611s-3.269 1.344-3.269 3.611z"/>
        </svg>
      )
    }
  ];

  return (
    <nav className={`social-nav ${isFooterOverlap ? 'footer-overlap' : ''}`}>
      <ul className="social-links">
        {socialLinks.map((social, index) => (
          <li key={social.name}>
            <a
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label={social.name}
            >
              {social.icon}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SocialNav;